import { AnimateSharedLayout, motion } from "framer-motion";
import Lottie from "lottie-react";
import { useState } from "react";
import { FiArrowLeft, FiTrash } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import { useRecoilState, useSetRecoilState } from "recoil";
import cartAnimation from "../animations/empty.json";
import { currentCart } from "../atoms/auth";
import { orderAtom } from "../atoms/checkoutManager";
import BottomNav from "../components/BottomNav";
import { auth } from "../functions/firebase";
import "./cart.css";

export default function Cart() {

    const navigate = useNavigate()
    const [cart, setCart] = useRecoilState(currentCart)
    const [selected, setSelected] = useState(null)
    const setOrder = useSetRecoilState(orderAtom)

    return (
        <div id="cart-wrapper">
            <div className="row centerX" style={{ width: "100%", padding: 15, backgroundColor: 'var(--header)' }}>
                <FiArrowLeft 
                    color="grey"
                    className="back-button"
                    size={30}
                    onClick={() => navigate(`/auth-1/${auth?.currentUser?.uid}`)}
                />
                <div>
                    <p>Your Cart</p>
                </div>
            </div>
            {cart.length === 0 && (
                <>
                    <Lottie 
                        animationData={cartAnimation}
                        style={{ width: window.innerWidth < 480 ? "70vw" : "20vw", margin: "20px auto", marginBottom: 0 }}
                        loop={false}
                    />
                </>
            )}
            <AnimateSharedLayout>
                <motion.div layout id="items-list" >
                    {cart.map((item, i) => (
                        <motion.div key={"item-" + item.title} className="cartItem row spaceBetween"
                            animate={{ height: selected === item.description ? 0 : "fit-content" }}
                            style={{ overflow: "hidden"}}
                        >
                            <div>
                                <p style={{ fontSize: 20, color: "#000" }}>{item.quantity} x {item.title}</p>
                                
                                {item?.sources?.length > 0 && <p style={{ color: "var(--secondary)" }}>{item?.sources?.join(", ")}</p>}

                                <h1 style={{ fontSize: 25, color: "#000" }}>R{item.itemTotal}</h1>
                            </div>
                            <div className="deleteCart"
                                onClick={() => {
                                    setSelected(item.title)
                                    setTimeout(() => {
                                        setCart(cart.filter((_, j) => i !== j))
                                    },200)
                                }}
                            >
                                <FiTrash size={27} color="#FFF" />
                            </div>
                        </motion.div>
                    ))}
                </motion.div>
                <button id="continue-shopping" onClick={() => {
                    navigate(`/auth-1/${auth.currentUser?.uid}`)
                }} style={{ marginBottom: 0, margin: "10px 5%", width:  window.innerWidth < 480 ? "90%" : "50%", backgroundColor: "var(--secondary)", color: "#fff" }}>Continue Shopping</button>
            </AnimateSharedLayout>
            {window.innerWidth < 480 && <div style={{ height: 180, width: 20 }} />}
            <BottomNav cart  onPress={() => {
                setOrder(c => ({ 
                    ...c, 
                    items: cart, 
                    phone: auth?.currentUser?.phoneNumber, 
                    title: auth.currentUser?.displayName 
                }))
                navigate(`/auth-1/${auth.currentUser?.uid}/cart/checkout`)
                }} 
            />
        </div>
    )
}